module.exports = __webpack_public_path__ + "static/media/LazyAz_web3.c8f82400.jpg";